var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticStyle:{"padding":"0","width":"100%","height":"100%"},attrs:{"src":_vm.url,"controls":""}})}
var staticRenderFns = []

export { render, staticRenderFns }